export default __webpack_public_path__ + "c9d6b1a407cda5355c6a68797ddfa88d.svg";